import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'count-card',
    templateUrl: './count-card.component.html',
    styleUrls: ['./count-card.component.scss'],
    standalone: false
})
export class CountCardComponent implements OnInit {

  @Input() title: string | undefined;
  @Input() firstCount: Number | undefined;
  @Input() firstCountDescription: string | undefined;
  @Input() secondCount: Number | undefined;
  @Input() secondCountDescription: string | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
